import { render, staticRenderFns } from "./VSwiperControl.vue?vue&type=template&id=ef9234ec&"
import script from "./VSwiperControl.vue?vue&type=script&lang=js&"
export * from "./VSwiperControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports